import useSWR, { SWRResponse } from 'swr';
import { baseFetcherV2 } from '../data/baseFetcherV2';

type ApplicationConfig = {
  prescriptionsConfig: {
    allowsPdfGeneration: boolean;
  };
};

export default function useConfig(): SWRResponse<ApplicationConfig> {
  return useSWR<ApplicationConfig>(`core/config/`, baseFetcherV2);
}
